import { render, staticRenderFns } from "./LineItem2.vue?vue&type=template&id=05e420de&scoped=true&"
import script from "./LineItem2.vue?vue&type=script&lang=js&"
export * from "./LineItem2.vue?vue&type=script&lang=js&"
import style0 from "./LineItem2.vue?vue&type=style&index=0&id=05e420de&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e420de",
  null
  
)

export default component.exports